export const AVATAR_COLORS = [
  '#7C3AED',
  '#BE185D',
  '#0D9488',
  '#15803D',
  '#B45309',
  '#0369A1',
] as const;

export const getAvatarColor = (key: string): string => {
  if (!key) return AVATAR_COLORS[0];

  let hash = 0;
  for (let i = 0; i < key.length; i += 1) {
    hash = key.charCodeAt(i) + ((hash << 5) - hash);
  }

  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

export const getInitials = (name: string): string => {
  if (!name) return '';

  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();

  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

export const getInitialsFromParts = (firstName?: string, lastName?: string): string =>
  getInitials(`${firstName ?? ''} ${lastName ?? ''}`.trim());

export const getDisplayName = (firstName?: string, lastName?: string): string =>
  `${firstName ?? ''} ${lastName ?? ''}`.trim();
